export const DetailProspectionTraitement = () => {
    return (
        <>
            <div className="bg-white p-4 text-center text-muted">
                Bientôt disponible...
            </div>
        </>
    )
}